import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import Product2skill2exp2rateEditFormImpl from './Product2skill2exp2rateEditFormImpl';
import Product2skill2exp2rateList from './Product2skill2exp2rateList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import Product2skill2exp2rateListView from './Product2skill2exp2rateListView'


export default function Product2skill2exp2rateDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.product2skill2exp2rateDashboard);
  const [ product2skill2exp2rateId, setProduct2skill2exp2rateId] = React.useState('');
  const [reloadProduct2skill2exp2rateList, setReloadProduct2skill2exp2rateList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <Product2skill2exp2rateEditFormImpl 
            setReloadProduct2skill2exp2rateList={setReloadProduct2skill2exp2rateList}
            product2skill2exp2rateId={product2skill2exp2rateId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <Product2skill2exp2rateListView 
                      setProduct2skill2exp2rateId = {setProduct2skill2exp2rateId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
